import React, { useState, useEffect, Fragment, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import ReactCodeInput from 'react-verification-code-input';
import { Link } from 'react-router-dom';
import { base_url } from '../Api/Api';
import { Loader } from '../Common/Loader';
import Popup from '../Common/Popup';
import EntrnaceHeader from './EntranceHeader';
import PulseLoader from "react-spinners/PulseLoader";
// api
import { Signle_Call } from '../Api/Api';
import Cookies from 'universal-cookie';

// login not working yet

const Enterverfcode = (props) => {
	const [Animation, setAnimation] = useState(false);
	const [time, setTime] = useState("02:00");
	const [state, setState] = useState({
		temp: 0,
		// loading: false,
		loader: false,
		Popup: false,
		validError: false,
		phoneNumber: JSON.parse(localStorage.getItem('phoneNumber')),
		verficationCode: null,
		errorText: '',
		errorCode: ''
	});

	useEffect(() => {
		activateTimer();
		setTimeout(() => {
			setAnimation(true);
		}, 100);
	}, []);

	const activateTimer = useCallback(() => {
		let resendCountDown = 120;

		const interval = setInterval(() => {
			if (resendCountDown === 0) {
				clearInterval(interval);
				setTime("")
			} else {
				const minutes = Math.floor(resendCountDown / 60);
				const seconds = resendCountDown % 60;
				setTime(
					`0${minutes}:${seconds}`
				);
				resendCountDown--;
			}

		}, 1000)
	},[])
	const handleVerfCode = (value) => {
		setState({
			...state,
			verficationCode: value,
			validError: false
		});
	};

	const resendCode = () => {
		activateTimer();
		setState({
			...state,
			validError: false
		});

		const Data = {
			mobile: state.phoneNumber
		};
		
		base_url.post('registerOrLogin', Data)
	};

	const contniue = () => {
		if (state.verficationCode !== null && state.verficationCode.length === 6) {
			localStorage.setItem('verfCode', JSON.stringify(state.verficationCode));
			setState({
				...state,
				loader: true,
				validError: false
			});
			const Data = {
				mobile: state.phoneNumber,
				code: state.verficationCode,
				'webpush_id': localStorage.getItem('gcm_id')
			};

			base_url
				.post('checkVerifyCode', Data)
				.then(async (response) => {
					const cookies = new Cookies()
					cookies.set("api_key", response.data.token, {
						maxAge: 604800,
						path: "/",
					})
					
					// ---------------------------------------
					const apiCall = () => {

						const apiCall = async (tools) => {
							const ApiCall = await Signle_Call(tools);
							return ApiCall;
						};
						return new Promise((result) => {
							result(
								apiCall({
									method: 'get',
									data: false,
									path: 'splash',

								})
							);
						});
					};
					const splash_result = await apiCall();
					setState({
						...state,
						loader: false
					});
					console.log(splash_result)
					if (splash_result.response.data.is_verify == 0 && response.data.registeredUser) {
						// not_is_verify
						localStorage.setItem('isVerfy', JSON.stringify(true));
						props.history.push('/Entrance')
					} else if (response.data.registeredUser == false) {
						// not_registred
						props.history.push('/Entrance/step3')
					} else if (splash_result.response.data.is_verify == 1 && response.data.registeredUser) {
						// registred & verify
						localStorage.setItem('logined', JSON.stringify(true));
						setTimeout(() => {
							props.history.push('/')
							window.location.reload()
						}, 500);
					}
					console.log(splash_result.response.data, 'mmdreza');
				})
				.catch((error) => {
					console.log(error.response);
					setState({
						...state,
						Popup: true,
						validError: true,
						loader: false,
						errorCode: error.response.status,
						errorText: error.response.data
					});
				});
		} else {
			setState({
				...state,
				validError: true
			});
		}
	};

	return (
		<Fragment>
			<EntrnaceHeader />
			<div className={`entrnc-web verficode ${Animation ? 'active' : ''}`}>
				{/* <Loader active={state.loader} /> */}
				<Popup active={state.Popup} active={state.statusDisAccount}>
					<div className="disable-account">
						<i className="icon-bell-fill" />
						<h4>{state.verficcationText}</h4>
						<div className="btn-base btn-black btn-sircle">
							<Button
								variant="contained"
								onClick={() => {
									window.close();
								}}
							>
								تایید
							</Button>
						</div>
					</div>
				</Popup>
				<div className="contain">
					<div className="bx-info">
						<div className="titles-style-1">
							<h4>کد تایید</h4>
						</div>
						<div className="info-inputs">
							<span>کد ارسالی به شماره تلفن زیر را وارد کنید.</span>
							<strong>{state.phoneNumber}</strong>
							<div className="input-code">
								<ReactCodeInput onChange={(e) => handleVerfCode(e)} />
								{state.validError ? (
									<span className={`error-respns active`}>
										<i className="icon-exclamation-mark" />
										کد را بصورت کامل وارد کنید
									</span>
								) : null}
								<div className="resend-time">
									<span
										className={`${!time ? 'active' : ''}`}
										onClick={resendCode} >ارسال مجدد کد</span>
									{time ? <span>{time}</span> : <></>}
								</div>
							</div>
						</div>
						<div className="btn-base btn-black btn-sircle">
							{state.loader ?
								<Button variant="contained">
									<PulseLoader
										color="#fff"
										loading={true}
										size={12} />
								</Button>
								:
								<Button variant="contained" onClick={contniue}>
									ادامه
								</Button>
							}
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	);
};

export default Enterverfcode;
